module.exports = __webpack_public_path__ + "img/CR.b6de7a34.svg";